'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _headerMenu = require('./headerMenu.scss');

var _headerMenu2 = _interopRequireDefault(_headerMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderMenu = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HeaderMenu, _Component);

  function HeaderMenu(props, context) {
    (0, _classCallCheck3.default)(this, HeaderMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderMenu.__proto__ || (0, _getPrototypeOf2.default)(HeaderMenu)).call(this, props, context));

    _this.linkClick = function (href, item, e) {

      e.preventDefault();

      _this.props.handleClickLink(event, false);
    };

    _this.newLinkClick = function () {
      _this.props.handleClickLink();
    };

    return _this;
  }

  (0, _createClass3.default)(HeaderMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let podcastsLinks = this.props.strings.menuLinks
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          strings = _props.strings,
          location = _props.location;


      var activeItemMenu = "";
      var links = strings.map(function (item, index) {
        activeItemMenu = "";
        if (location.pathname === item.href) {
          activeItemMenu = "headerMenu__list__item__link--active";
        }
        return _react2.default.createElement(
          'li',
          { key: "headerMenu" + index, className: 'headerMenu__list__item' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: item.href, className: "headerMenu__list__item__link " + activeItemMenu, onClick: _this2.newLinkClick },
            item.text,
            _react2.default.createElement(
              'span',
              { className: 'headerMenu__list__item__link__subText' },
              item.text2
            )
          )
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'headerMenu' },
        _react2.default.createElement(
          'nav',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'headerMenu__list' },
            links
          )
        )
      );
    }
  }]);
  return HeaderMenu;
}(_react.Component), _class.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  project: _propTypes2.default.string.isRequired
}, _temp);
exports.default = HeaderMenu;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Header/HeaderMenu.jsx
// module id = 703
// module chunks = 0